smoothly-button-demo {
	display: block;
	margin: 1rem;
}

smoothly-button-demo > section > div {
	display: flex;
	align-items: center;
}

smoothly-button-demo smoothly-button {
	margin: .2em .5em;
}
